(function (app) {
    app.provider("lineOfBusinessCategoryApi", [function () {
        this.$get = ["complianceHubApiGateway", "$q", function (complianceHubApiGateway, $q) {
            var service = {};

            service.getCategories = function () {
                return complianceHubApiGateway.getArray("/LineOfBusinessCategories");
            };
          
            service.getCategory = function(lineOfBusinessCategoryId) {
                return complianceHubApiGateway.get("/LineOfBusinessCategories/" + lineOfBusinessCategoryId);
            };

            service.createLineOfBusinessCategory = function(LineOfBusinessCategoryModel) {
                return complianceHubApiGateway.post("/LineOfBusinessCategories", LineOfBusinessCategoryModel);
            };

            service.updateLobCatName = function(lineOfBusinessCategoryModel) {
                return complianceHubApiGateway.put("/LineOfBusinessCategories/" + lineOfBusinessCategoryModel.Id, lineOfBusinessCategoryModel);
            };

            return service;
        }];
    }]);
})(window.app); // jshint ignore:line